var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.item.title}},[(_vm.item.status==='true'||_vm.item.camStatus==='1')?_c('img',{attrs:{"src":require("@/assets/green.png")}}):_c('img',{attrs:{"src":require("@/assets/red.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }